<template>
  <div class="modal-card" style="width: 100%">
    <header class="modal-card-head">
      <p class="modal-card-title">Log</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <b-tabs v-model="activeTab">
        <b-tab-item label="Full Log" value="full">
          <codemirror v-model="linesStr" :options="cmOptions" v-on:beforeChange="changed"></codemirror>
        </b-tab-item>
        <b-tab-item label="API Requests" value="api">
          <b-table :data="this.requests" detailed sticky-header>
            <b-table-column label="Time" v-slot="props">
              {{ props.row.timestamp }}
            </b-table-column>
            <b-table-column label="Url" v-slot="props">
              {{ props.row.request.message.url }}
            </b-table-column>
            <template #detail="props">
              Body:
              <json-viewer :value="props.row.request.message.body"></json-viewer>
              Response:
              <json-viewer :value="props.row.request.message.result"></json-viewer>
            </template>
          </b-table>
        </b-tab-item>
      </b-tabs>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$emit('close')">Close</button>
    </footer>
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
  </div>
</template>

<script>
const axios = require("axios");
import JsonViewer from "vue-json-viewer";

export default {
  props: ["dateFrom", "dateTo", "hostname", "callid", "logsUrl", "uniqueId", "region"],
  components: {
    JsonViewer,
  },
  data: function () {
    return {
      activeTab: "full",
      lines: [],
      requests: [],
      linesStr: "",
      isLoading: false,
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: "text/javascript",
        theme: "dracula",
        lineNumbers: true,
        line: true,
        viewportMargin: Infinity,
      },
    };
  },
  methods: {
    dateFormatter(dt) {
      const mnth = ("0" + (dt.getMonth() + 1)).slice(-2);
      const day = ("0" + dt.getDate()).slice(-2);
      const hours = ("0" + dt.getHours()).slice(-2);
      const minutes = ("0" + dt.getMinutes()).slice(-2);
      return [dt.getFullYear(), mnth, day].join("-") + "T" + [hours, minutes, "00"].join(":");
    },
    GetItems: async function () {
      const from = this.dateFormatter(this.dateFrom);
      const to = this.dateFormatter(this.dateTo);
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      console.log(config);
      axios
        .get(`${this.logsUrl}/logs/${this.hostname}/calls/${this.callid}?dateFrom=${from}&dateTo=${to}&region=${this.region}`, config)
        .then((response) => {
          this.lines = response.data;
          this.linesStr = "";
          const bufferedThis = this;
          this.lines.forEach((line) => {
            bufferedThis.linesStr += "[" + line.timestamp + "] " + line.message + "\n";
          });
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
          this.isLoading = false;
        });
    },
    GetRequests: async function () {
      const from = this.dateFormatter(this.dateFrom);
      const to = this.dateFormatter(this.dateTo);
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios
        .get(`${this.logsUrl}/logs/${this.hostname}/calls/${this.uniqueId}/requests?dateFrom=${from}&dateTo=${to}&region=${this.region}`, config)
        .then((response) => {
          this.requests = response.data;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
          this.isLoading = false;
        });
    },
    changed: function (instance, changeObj) {
      if (changeObj.origin != "setValue") changeObj.cancel();
    },
  },
  mounted() {
    this.GetItems();
    this.GetRequests();
  },
};
</script>

<style>
.CodeMirror {
  border: 1px solid #eee;
  height: 65vh !important;
}
.cm-s-dracula.CodeMirror,
.cm-s-dracula .CodeMirror-gutters {
  background-color: #282a36 !important;
  color: #f8f8f2 !important;
  border: none;
}
.cm-s-dracula .CodeMirror-gutters {
  color: #282a36;
}
.cm-s-dracula .CodeMirror-cursor {
  border-left: solid thin #f8f8f0;
}
.cm-s-dracula .CodeMirror-linenumber {
  color: #6d8a88;
}
.cm-s-dracula .CodeMirror-selected {
  background: rgba(255, 255, 255, 0.1);
}
.cm-s-dracula .CodeMirror-line::selection,
.cm-s-dracula .CodeMirror-line > span::selection,
.cm-s-dracula .CodeMirror-line > span > span::selection {
  background: rgba(255, 255, 255, 0.1);
}
.cm-s-dracula .CodeMirror-line::-moz-selection,
.cm-s-dracula .CodeMirror-line > span::-moz-selection,
.cm-s-dracula .CodeMirror-line > span > span::-moz-selection {
  background: rgba(255, 255, 255, 0.1);
}
.cm-s-dracula span.cm-comment {
  color: #6272a4;
}
.cm-s-dracula span.cm-string,
.cm-s-dracula span.cm-string-2 {
  color: #f1fa8c;
}
.cm-s-dracula span.cm-number {
  color: #bd93f9;
}
.cm-s-dracula span.cm-variable {
  color: #50fa7b;
}
.cm-s-dracula span.cm-variable-2 {
  color: white;
}
.cm-s-dracula span.cm-def {
  color: #50fa7b;
}
.cm-s-dracula span.cm-operator {
  color: #ff79c6;
}
.cm-s-dracula span.cm-keyword {
  color: #ff79c6;
}
.cm-s-dracula span.cm-atom {
  color: #bd93f9;
}
.cm-s-dracula span.cm-meta {
  color: #f8f8f2;
}
.cm-s-dracula span.cm-tag {
  color: #ff79c6;
}
.cm-s-dracula span.cm-attribute {
  color: #50fa7b;
}
.cm-s-dracula span.cm-qualifier {
  color: #50fa7b;
}
.cm-s-dracula span.cm-property {
  color: #66d9ef;
}
.cm-s-dracula span.cm-builtin {
  color: #50fa7b;
}
.cm-s-dracula span.cm-variable-3,
.cm-s-dracula span.cm-type {
  color: #ffb86c;
}

.cm-s-dracula .CodeMirror-activeline-background {
  background: rgba(255, 255, 255, 0.1);
}
.cm-s-dracula .CodeMirror-matchingbracket {
  text-decoration: underline;
  color: white !important;
}

.modal .animation-content {
  margin: 0 20px;
  width: 98%;
}
.b-table .table tr.detail .detail-container {
  display: block !important;
}
</style>
